import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {httpGetAbsences, HttpGetAbsencesOptions, HttpGetAbsencesResponse} from '../http/accesses.http'

export const useGetAbsences = ({
    params,
    options
}: {
    params: HttpGetAbsencesOptions['params']
    options?: Pick<UseInfiniteQueryOptions<HttpGetAbsencesResponse>, 'enabled'>
}) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.ABSENCES, params],
        queryFn: ({pageParam}) =>
            httpGetAbsences({
                params: {
                    ...params,
                    page: pageParam
                }
            }),
        initialPageParam: 1,
        getNextPageParam: lastPage => {
            const currentPage = lastPage.meta?.currentPage || 0
            const lastPageNumber = lastPage.meta?.lastPage || 0

            return currentPage < lastPageNumber ? currentPage + 1 : undefined
        },
        ...options
    })

    return {
        ...query,
        data: query.data?.pages.flatMap(page => page.data)
    }
}
